import React, { useRef, useEffect, useState } from 'react'
import cl from 'classnames'
import styles from './ViewerTabTable.module.scss'
// import { totalWatchColumns, tableFeedLines, TotalWatchColTypes } from './total-watch-columns'
import { TableHeader } from './TableHeader'
// import { TableLine } from './TableLine'
import { ViewerTabTableProps, SortingState, ViewerPageTableLine } from './types'
import { InfoMessage } from 'components/common'
import { TableLineHandler } from './TableLineHandler'
import { isDescending, SortDirection } from 'utilities'
import { ParentLineWrapper } from './ParentLineWrapper'

function ViewerTabTableComponent<TabType> (props: ViewerTabTableProps<TabType>) {
  const { colKeys, columns, rows } = props
  const container = useRef<HTMLDivElement>()
  const [scrollableMaxHeight, setScrollableMaxHeight] = useState(500)
  const initialSortingState = {} as SortingState

  colKeys.forEach((key: any) => {
    if (columns[key].sortable) {
      initialSortingState[key] = SortDirection.DESC
    }
  })
  const [sorting, setSorting] = useState<SortingState>(initialSortingState)

  useEffect(() => {
    const setMaxHeight = () => setScrollableMaxHeight(container.current.clientHeight - 50)
    setMaxHeight()

    window.addEventListener('resize', setMaxHeight, false)
    return () => window.removeEventListener('resize', setMaxHeight, false)
  }, [container])

  const headerColumns = colKeys.map((key: any) => {
    const sortDirection = sorting[key]
    const toggleSortDirection = () => setSorting(state => ({
      ...state,
      [key]: isDescending(sortDirection)
        ? SortDirection.ASC
        : SortDirection.DESC
    }))

    return {
      ...columns[key],
      sortDirection,
      toggleSortDirection
    }
  })

  const applySorting = (rowList: ViewerPageTableLine[]) => {
    if (!rowList) return
    const compare = (a: ViewerPageTableLine, b: ViewerPageTableLine) => {
      const results = []
      Object.keys(sorting).forEach(key => {
        const resultForThisKey = isDescending(sorting[key])
          ? b[key].sortableValue - a[key].sortableValue
          : a[key].sortableValue - b[key].sortableValue

        results.push(resultForThisKey)
      })

      let result
      results.forEach(r => {
        result = result || r
      })

      return result || 0
    }
    rowList.sort(compare).forEach(row => applySorting(row.children))
  }

  applySorting(rows)

  return (
    <div className={styles.container} ref={container}>
      <TableHeader<TabType>
        columns={headerColumns}
      />

      <div
        className={cl(styles.body, styles.scrollable)}
        style={{ maxHeight: scrollableMaxHeight }}
      >

        {(!rows || !rows.length) && <InfoMessage style={{ height: '100%' }} />}
        {rows.map((row, index) => {
          return (
            <ParentLineWrapper key={index + colKeys.join()}>
              {(toggleShowFrame) =>
                <TableLineHandler<TabType>
                  row={row}
                  colKeys={colKeys}
                  columns={columns}
                  onToggleExpand={toggleShowFrame}
                />
              }
            </ParentLineWrapper>
          )
        })}

      </div>
    </div>
  )
}

const ViewerTabTable = ViewerTabTableComponent
export { ViewerTabTable }
